import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

type Editorial = {
  id: number;
  judul: string;
  gambar: string;
  deskripsi: string;
  created_at: string;
};

const BeritaTerkini: React.FC = () => {
  const [news, setNews] = useState<Editorial[]>([]);
  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchNews = async () => {
      const res = await axios.get(`${API}/api/editorial`);
      setNews(res.data.data);
    };

    fetchNews();
  }, [API]);

  if (news.length < 2) return null;

  const mainNews = news[1]; // index mulai dari 1
  const sideNews = news.slice(2, 7);

  return (
    <section className="mb-12 mt-5">
      {/* TITLE */}
      <div className="flex items-center mb-8">
        <div className="bg-primary text-white px-4 py-2 font-semibold">PROGRAM PRIORITAS</div>
        <div className="flex-1 border-b-2 border-primary"></div>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        {/* MAIN NEWS */}

        <Link to={`berita/${mainNews?.id}`}>
          <div className="group cursor-pointer">
            <img alt="" src={mainNews.gambar} className="w-full h-[350px] object-cover" />

            <div className="mt-4">
              <p className="text-gray-500 text-sm mt-2">{new Date(mainNews.created_at).toLocaleDateString("id-ID")}</p>
              <h2 className="text-2xl font-bold mt-2 leading-snug group-hover:text-primary transition">{mainNews.judul}</h2>

              <p className="text-gray-600 mt-3 line-clamp-3" dangerouslySetInnerHTML={{ __html: mainNews.deskripsi }} />
            </div>
          </div>
        </Link>

        {/* SIDE NEWS */}
        <div className="space-y-6">
          {sideNews.map((item) => (
            <Link to={`berita/${item?.id}`} key={item.id} className="flex gap-4 group cursor-pointer">
              <img alt="" src={item.gambar} className="w-28 h-20 object-cover" />

              <div>
                <h3 className="font-semibold leading-snug group-hover:text-primary transition">{item.judul}</h3>

                <p className="text-sm text-gray-500 mt-1">{new Date(item.created_at).toLocaleDateString("id-ID")}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeritaTerkini;
